<div class="row">
    <div class="col-lg-6 align-self-center" *ngIf="!context.imageRight">
        <app-image [context]="context.image"></app-image>
    </div>
    <div class="col-lg-6 align-self-center">
        <app-building-block *ngFor="let block of context.blocks"
                            [context]="block.context" [type]="block.name"
        ></app-building-block>
    </div>
    <div class="col-lg-6 align-self-center" *ngIf="context.imageRight">
        <app-image [context]="context.image"></app-image>
    </div>
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/building-blocks/image-paragraph/image-paragraph.component.html